/**
 * Functionality for the HM Pricing block.
 *
 * Adapted from the code provided on https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role
 */

/**
 * Change to pricing items.
 *
 * @param {HTMLElement} pricingTarget Pricing element.
 */
function activatePricing( pricingTarget ) {
	const pricingContents = document.querySelectorAll( '.wp-block-kaplan-pricing-item' );
	const pricingFooter = document.getElementById( 'kaplan-pricing__footer' );

	// Hide all pricing panels
	pricingContents.forEach( p => {
		if ( p.getAttribute( 'id' ) === pricingTarget ) {
			p.removeAttribute( 'hidden' );
		} else {
			p.setAttribute( 'hidden', true );
		}
	} );

	// Show the footer.
	if ( pricingFooter ) {
		pricingFooter.removeAttribute( 'hidden' );
	}
}

/**
 * Handle click event on tab.
 *
 * @param {object} e Event
 */
function handleTabClick( e ) {
	activatePricing( e.target.value );
}

/**
 * Handle key navigation on tab element.
 *
 * @param {object} e Event
 */
function handleKeydown( e ) {
	if ( ! ( e.keyCode === 39 || e.keyCode === 37 ) ) {
		return;
	}

	const blockElement = e.target.closest( '.kaplan-pricing' );
	const tab = blockElement.querySelector( '[role="tab"][aria-selected="true"]' );
	const tabs = blockElement.querySelectorAll( '[role="tab"]' );

	const currentTabIndex = Array.from( tabs ).findIndex( t => tab.getAttribute( 'id' ) === t.getAttribute( 'id' ) );

	// Work out the next tab.
	let nextTabIndex = e.keyCode === 37 ? currentTabIndex - 1 : currentTabIndex + 1;
	nextTabIndex = Math.min( Math.max( nextTabIndex, 0 ), tabs.length );

	if ( nextTabIndex !== currentTabIndex ) {
		activatePricing( tabs[ nextTabIndex ] );
		tabs[ currentTabIndex ].blur();
		tabs[ nextTabIndex ].focus();
	}
}

/**
 * Initialize tab block.
 *
 * Ensure initial state is correct.
 *
 * @param {HTMLElement} blockElement Tab block.
 */
const initPricingBlock = ( blockElement ) => {
	const tabs = blockElement.querySelectorAll( '[role="tab"]' );
	const tabList = blockElement.querySelector( '[role="tablist"]' );

	blockElement.addEventListener( 'change', handleTabClick );

	// Hide all panels except the first one.
	tabs.forEach( tab => {
		const panel = document.getElementById( tab.getAttribute( 'aria-controls' ) );
		const isActive = tab.classList.contains( 'kaplan-pricing__item--active' );

		if ( isActive ) {
			panel.removeAttribute( 'hidden' );
		} else {
			panel.setAttribute( 'hidden', true );
		}
	} );

	tabList.addEventListener( 'keydown', handleKeydown );
};

/**
 * Kick it all off.
 */
function bootstrap() {
	document.querySelectorAll( '.kaplan-pricing' )
		.forEach( el => initPricingBlock( el ) );
}

document.addEventListener( 'DOMContentLoaded', bootstrap );
